import { useCallback, useState } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { downloadCallRecording, DownloadCallRecordingParams } from './call-recording-utils';

export const useDownloadCallRecording = () => {
  const alert = useAlert();
  const { t } = useTranslation('calls');
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadMedia = useCallback(
    async (params: DownloadCallRecordingParams) => {
      try {
        setIsDownloading(true);
        await downloadCallRecording(params);
      } catch (e) {
        alert.error(t('unable to download the media'));
      } finally {
        setIsDownloading(false);
      }
    },
    [alert, t]
  );

  return { downloadMedia, isDownloading };
};
